import { defineComponent as _defineComponent } from 'vue'
import { IWithdrawDetails } from '@/modules/transaction/services/withdraw-by-portfolio';
import { HeadingDisplay, ListDisplay, Modal } from '@warrenbrasil/nebraska-web';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ModalAvailableForRedemption',
  props: {
    isOpen: { type: Boolean },
    withdrawDetails: null
  },
  setup(__props: any) {

const props = __props as {
  isOpen: boolean;
  withdrawDetails: IWithdrawDetails;
};



const availableForRedemption = computed(() => [
  {
    title: 'Saldo atual na carteira',
    value: props.withdrawDetails.currentBalance.formatted
  },
  {
    title: 'Em rebalanceamento',
    value: props.withdrawDetails.inRebalance.formatted
  },
  {
    title: 'Em resgate',
    value: props.withdrawDetails.inRedemption.formatted
  },
  {
    title: 'Aplicações em processamento',
    value: props.withdrawDetails.inProcessing.formatted
  },
  {
    title: 'Saldo disponível para resgate',
    value: props.withdrawDetails.availableToRedemption.formatted
  }
]);

return { __sfc: true,props, availableForRedemption, HeadingDisplay, ListDisplay, Modal }
}

})